import http from "./http";

/* ----------------------------------------
   CALCULATE CFT
---------------------------------------- */
export const calculateCFT = async (payload) => {
  const res = await http.post("calculate_cft", {
    wood_type: payload.wood_type,
    length_in: Number(payload.length_in),
    width_in: Number(payload.width_in),
    thickness_in: Number(payload.thickness_in),
    qty: Number(payload.qty),
  });

  return res.data;
};
